import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from "@angular/core";
import { ApiService, MathUtils } from "../../../../../../../shared/src";
import { LiveUpdateService } from "../../../../../../../shared/src/lib/services/live-update.service";
import { CoreService } from "../../../../../../../shared/src/lib/services/core.service";
import { NavService } from "../../../../../../../shared/src/lib/services/nav.service";
import { AsyncPipe, DecimalPipe, NgClass } from "@angular/common";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { TranslateModule } from "@ngx-translate/core";
import { Observable, Subject } from "rxjs";
import { LoaderService } from "../../../../../../../shared/src/lib/services/loader.service";
import { MatIconModule } from "@angular/material/icon";
import { BetPlacementService } from "../../../../../../../shared/src/lib/services/bet-placement.service";
import { BalanceService } from "../../../../../../../shared/src/lib/services/balance.service";
import { ExRateService } from "../../../../../../../shared/src/lib/services/ex-rate.service";
import { UserButtonComponent } from "../user-button/user-button.component";
import { TruncateNumberPipe } from "../../../../../../../shared/src/lib/pipe/truncate-number.pipe";
import { environment } from "../../../../../../../shared/src/environments/environment";
import { WhiteLabelConfigService } from "../../../../../../../shared/src/lib/services/white-label-config.service";
import { takeUntil, map } from "rxjs/operators";
import {MatTooltip} from "@angular/material/tooltip";

@Component({
  selector: "app-balance-display",
  imports: [MatProgressSpinnerModule, TranslateModule, DecimalPipe, MatIconModule, AsyncPipe, NgClass, UserButtonComponent, TruncateNumberPipe, MatTooltip],
  templateUrl: "./balance-display.component.html",
  styleUrl: "./balance-display.component.scss",
})
export class BalanceDisplayComponent implements OnDestroy, OnInit {
  readonly destroy$ = new Subject<void>();
  loader = inject(LoaderService);
  user: any = null;
  apiService = inject(ApiService);
  balanceService = inject(BalanceService);
  exRateService = inject(ExRateService);
  liveUpdateService = inject(LiveUpdateService);
  coreService = inject(CoreService);
  navService = inject(NavService);
  placementService = inject(BetPlacementService);
  whiteLabelConfigService = inject(WhiteLabelConfigService);
  cdr = inject(ChangeDetectorRef);
  $loading!: Observable<boolean>;

  balanceData: any = {
    BALANCE: "0",
    RISK_EXPOSURE: "0",
    LIABILITY: "0",
    TOTAL_EXPOSURE: "0",
  };

  constructor() {
    this.balanceService.fetchBalance();
  }

  get balance() {
    return MathUtils.roundDown(+this.balanceData.BALANCE, 2);
  }

  get liability() {
    return +this.balanceData.LIABILITY;
  }

  get totalExposure() {
    return +this.balanceData.TOTAL_EXPOSURE;
  }

  get availableToBet() {
    // return this.balance + this.totalExposure - this.liability;
    return MathUtils.roundDown(this.balance + this.totalExposure, 2);
  }

  get isDev() {
    return /dev/i.test(environment.sURL);
  }

  get showCurrency() {
    return this.whiteLabelConfigService.showFeature("showCurrency");
  }

  ngOnInit() {
    this.$loading = this.loader.isLoading("/v1/api/refresh_exposure");
    this.getBalance();
  }

  getBalance() {
    this.balanceService.balanceData$.pipe(takeUntil(this.destroy$)).subscribe((balance: any) => {
      // console.log(balance);
      this.balanceData = {
        ...balance,
        BALANCE: balance?.BALANCE || "0",
        RISK_EXPOSURE: balance?.RISK_EXPOSURE || "0",
        LIABILITY: balance?.LIABILITY || "0",
        TOTAL_EXPOSURE: balance?.TOTAL_EXPOSURE || "0",
      };
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
